import styled from "styled-components";
import { Button, Menu as CommonMenu } from "antd";

const NavbarContainer = styled.div`
  height: 100px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  background: radial-gradient(ellipse at top, #000000, #142b22);
`;

const Menu = styled(CommonMenu)`
  align-items: center;
  height: fit-content;
  display: flex;
`;

const NameContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-right: 15px;
`;

const ProfileButton = styled(Button)`
  height: 100%;
  display: flex;
  align-items: center;
`;

export { NavbarContainer, Menu, ProfileButton, NameContainer };
